<!-- Copyright (c) 2019-2024 Cigent Technology Inc. All Rights Reserved. -->
<div class="policy-list-wrapper" role="application">

    <span class="add-folder-btn">
        <button mat-icon-button color="primary" (keydown.enter)="enableNewMode()" (click)="enableNewMode()"
                aria-label="Add policy" matTooltip="{{fAdd}}" [disabled]="reorderMode || renameMode || newMode">
            <span class="mdi mdi-plus-box-outline"></span>
        </button>
        <button mat-icon-button color="primary" (click)="clonePolicy(loadedPolicy, $event)" aria-label="Clone policy"
                matTooltip="{{'PL_CLONE_TIP' | translate}}" [disabled]="reorderMode || renameMode || newMode">
            <span class="mdi mdi-content-copy"></span>
        </button>
        <button mat-icon-button color="primary" (click)="deletePolicy(loadedPolicy, $event)" aria-label="Delete policy"
                matTooltip="{{fDeleteTip}}" [disabled]="reorderMode || renameMode || newMode">
            <span class="mdi mdi-trash-can"></span>
        </button>
    </span>

    <span tabindex="-1" aria-live="assertive" class="assistive-text">{{announcement}}</span>
    <span tabindex="-1" id="operation" class="assistive-text">
{{fReorder}}
    </span>

    <mat-card class="list-card" appearance="raised">
        <mat-list class="policy-mat-list" cdkDropList (cdkDropListDropped)="drop($event)">
            <ng-container *ngIf="!reorderMode">
                <mat-list-item tabindex="0" *ngFor="let policy of policies; let i = index" 
                        (keydown.enter)="loadPolicy(policy)" (click)="loadPolicy(policy)"
                        [ngClass]="policy.id === loadedPolicy && !newMode ? 'selected' : ''">
                    <div class="policy-list-item">
                        <div id="{{policy.name}}" class="policy-name" *ngIf="policy.id !== loadedPolicy">{{policy.name}}<span *ngIf="i == policies.length - 1"> (default)</span></div>
                        <div id="{{policy.name}}" class="policy-name" *ngIf="policy.id === loadedPolicy && !renameMode">{{policy.name}}<span *ngIf="i == policies.length - 1"> (default)</span></div>
                        <div id="{{policy.name}}" class="policy-name action-items" *ngIf="policy.id === loadedPolicy && renameMode">
                            <span class="input-wrapper">
                              <input matInput type="text" autocomplete="off" [(ngModel)]="renameTo"
                                   (keydown.enter)="renamePolicy($event)" (keydown.esc)="disableRenameMode($event)"
                                   #renameInput maxlength="255" class="policy-name-input">
                            </span>
                            <button matSuffix mat-icon-button (click)="renamePolicy($event)" class="icon-button"
                                    matTooltip="{{'SAVE' | translate}}" matTooltipPosition="above">
                                <span class="mdi mdi-check"></span>
                            </button>
                            <button matSuffix mat-icon-button (click)="disableRenameMode($event)" class="icon-button"
                                    matTooltip="{{'CANCEL' | translate}}" matTooltipPosition="above">
                                <span class="mdi mdi-close"></span>
                            </button>
                        </div>
                    </div>
                </mat-list-item>
            </ng-container>
            <ng-container *ngIf="reorderMode">
                <mat-list-item tabindex="0" aria-describedby="operation" [attr.data-target-index]="i" [attr.data-target-name]="policy.name" *ngFor="let policy of policies; let i = index" cdkDrag cdkDragLockAxis="y" #policyListItems>
                    <div class="policy-list-item policy-list-item-dragable">
                        <div class="policy-name">
                            <span class="mdi mdi-drag-vertical drag-vertical-icon"></span>{{policy.name}}<span *ngIf="i == policies.length - 1"> (default)</span>
                        </div>
                    </div>
                </mat-list-item>
            </ng-container>
            <mat-list-item *ngIf="newMode && !reorderMode">
              <div class="policy-list-item">

                <span class="input-wrapper">
                    <input matInput type="text" placeholder="{{fNewTip}}"  autocomplete="off" [(ngModel)]="newName"
                           (ngModelChange)="newNameChange()" (keydown.esc)="disableNewMode()" class="policy-name-input"
                            #newInput maxlength="155">
                </span>
                <div class="policy-name action-items">
                  <button [disabled]="this.nameError != null" matSuffix mat-icon-button (keydown.enter)="addPolicy()"
                          (click)="addPolicy()" class="icon-button" matTooltip="{{'SAVE' | translate}}"
                          matTooltipPosition="above">
                      <span class="mdi mdi-check"></span>
                  </button>
                  <button matSuffix mat-icon-button (click)="disableNewMode()" class="icon-button"
                          matTooltip="{{'CANCEL' | translate}}" matTooltipPosition="above">
                      <span class="mdi mdi-close"></span>
                  </button>
                  <mat-hint class='error-hint' [hidden]="this.nameError == null">{{nameError | translate}}</mat-hint>
                </div>
              </div>
            </mat-list-item>
        </mat-list>
        <div class="reorder-wrapper">
            <div class="reorder-button-wrapper">
                <div *ngIf="reorderMode">   
                    <button mat-raised-button (keydown.enter)="cancelReorderMode()" (click)="cancelReorderMode()">{{fCancel}}</button>
                    <button class="apply-button" mat-raised-button (click)="applyReorderMode()">{{fApply}}</button>
                </div>
                <div *ngIf="!reorderMode">
                    <button mat-raised-button (click)="enableReorderMode()" [disabled]="newMode || renameMode">{{fReorderButton}}</button>
                </div>
            </div>
            {{fNoteA}}
            {{fNoteB}}
            {{fNoteC}}
        </div>
    </mat-card>
</div>
